import {ChangeDetectionStrategy, Component} from '@angular/core';
import {Title} from '../../../../components/title/title';
import {TranslatePipe} from '@ngx-translate/core';
import {TabItem, TabMenu} from '../../../../components/tab-menu/tab-menu';
import {RouterOutlet} from '@angular/router';
import {RouteUri} from '../../../../constants/route-uri';

@Component({
  selector: 'elcia-timesheets-summary',
  imports: [
    Title,
    TranslatePipe,
    TabMenu,
    RouterOutlet,
  ],
  templateUrl: './timesheets-summary.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TimesheetsSummary {

  protected readonly items: TabItem[] = [
    {
      icon: 'clock',
      label: 'entity.timesheets',
      route: RouteUri.TIMESHEETS_LIST,
    },
    {
      icon: 'phone',
      label: 'entity.call-statistics',
      route: RouteUri.CALL_STATISTICS,
    },
  ];

}
